export const MODAL_ADD_CATEGORY = 'MODAL_ADD_CATEGORY'
export const MODAL_EDIT_CATEGORY = 'MODAL_EDIT_CATEGORY'
export const MODAL_ADD_SUBCATEGORY = 'MODAL_ADD_SUBCATEGORY'
export const MODAL_EDIT_SUBCATEGORY = 'MODAL_EDIT_SUBCATEGORY'
export const MODAL_ADD_FIELD = 'MODAL_ADD_FIELD'
export const MODAL_EDIT_FIELD = 'MODAL_EDIT_FIELD'
export const MODAL_DELETE_CATEGORY = 'MODAL_DELETE_CATEGORY'
export const MODAL_DELETE_SUBCATEGORY = 'MODAL_DELETE_SUBCATEGORY'
export const MODAL_DELETE_FIELD = 'MODAL_DELETE_FIELD'
